<template>
  <div class="pa-3">
    <v-form @submit.prevent="next">
       <v-alert
    v-if="ShowErrorMessage&&!mandatoryFieldCompiled"
      color="red darken-4"
      dark
      icon="mdi-alert-octagon-outline"
      dense
    >
      Inserisci una descrizione per questo evento.
    </v-alert> 
      <v-text-field
        ref="input"
        v-model="eventInfo.descrizione"
        class="mb-9"
        outlined
        label="Descrizione Intervento"
        name="headquarter"
        type="text"
      />
    </v-form>

    <v-form @submit.prevent="next">
      <v-text-field
        ref="input"
        v-model="eventInfo.commessa.descrizione"
        class="mb-9"
        outlined
        label="Commessa"
        name="commessa"
        type="text"
      />
    </v-form>

    <v-textarea
      clearable
      clear-icon="mdi-close-circle"
      label="Note"
      auto-grow
      rows="1"
      row-height="15"
      outlined
      v-model="eventInfo.note"
    ></v-textarea>

    <v-checkbox v-model="lampeggia" label="Metti in evidenza"></v-checkbox>
  </div>
</template>

<script>
import EasyPlanClient from "../../../utils/EasyPlanClient";
export default {
  props: ["eventInfo"],
  // watch: {},
  watch:{
    eventInfo : function (oldVal, newVal){
      console.log("prop changed")
      this.ShowErrorMessage=false;
    }, 
  },

  data: () => ({
    error: null,
    name: "",
    ShowErrorMessage:false,
    Info: null,
    disabled: false,
    dialog: false,
    selectedClient: "",
    selectedSede: "",
    row: 0,
    sede: [],

    clients: [],

    clientInfo: {
      descrizione: "",
      indirizzo: "",
      cap: "",
      citta: "",
      provincia: "",
      telefono: "",
      mail: "",
    },
  }),
  computed: {
    mandatoryFieldCompiled:{
      get(){
        return Boolean(
          !this.isEmptyOrSpaces(this.eventInfo.descrizione )
        )
      }
    },
    lampeggia: {
      get() {
        return Boolean(
          this.eventInfo.lampeggia == "true" || this.eventInfo.lampeggia == true
        );
      },
      set(value) {
        this.eventInfo.lampeggia = value;
      },
    },
  },
  mounted() {
    console.log(this.eventInfo);
    // eventInfo:this.eventInfo,
  },

  created() {
    this.initialize();
  },

  methods: {
    show: function () {
      alert();
    },
    CanGoFarward() {
      this.ShowErrorMessage=true;
      return this.mandatoryFieldCompiled; // > 0;
    },
    isEmptyOrSpaces: function (str) {
      return str === null || str.match(/^ *$/) !== null;
    },
    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
    },
  },
};
</script>

<style>
.addCliente {
  margin-top: 12px;
}

.addIntervento {
  margin-top: 12px;
}
</style>